module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/BattleTitleTooltip/images/reward-bg.bf95f65f.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/BattleTitleTooltip/images/reward-bg.png
// module id = 2505
// module chunks = 11